var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-card',{staticClass:"com-card-item-wrapper"},[(_setup.props.tips)?_c(_setup.CommonTooltip,{staticClass:"com-card-item-tooltip",attrs:{"tooltip":_setup.props.tips}}):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }